import { allEnumValues, FulfillmentMethod } from '@biteinc/enums';
export const getMenu = {
    method: 'GET',
    paths: ['/api/orgs/:orgId/locations/:locationId/menu'],
    fields: {
        fulfillmentMethod: {
            type: 'int',
            values: allEnumValues(FulfillmentMethod),
        },
        time: {
            type: 'timestamp',
        },
        outpostId: {
            type: 'mongoId',
        },
        forcedMenuStructureId: {
            type: 'mongoId',
        },
    },
};
//# sourceMappingURL=locations_get_menu.js.map